const FavoriteTypes = {
  TOGGLE_ITEM : 'TOGGLE_ITEM',
  CHECK_ITEM : 'CHECK_ITEM',
  CHECK_SWITCH: 'CHECK_SWITCH'
}

export default FavoriteTypes;